export var createReadElementContent = function createReadElementContent(readVariableSizeInteger) {
  return function (dataView, offset, type) {
    var channelCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
    var lengthAndValue = readVariableSizeInteger(dataView, offset);
    if (lengthAndValue === null) {
      return lengthAndValue;
    }
    var length = lengthAndValue.length,
      value = lengthAndValue.value;
    if (type === 'master') {
      return {
        content: null,
        length: length
      };
    }
    if (offset + length + value > dataView.byteLength) {
      return null;
    }
    if (type === 'binary') {
      var numberOfSamples = (value / Float32Array.BYTES_PER_ELEMENT - 1) / channelCount;
      var content = Array.from({
        length: channelCount
      }, function () {
        return new Float32Array(numberOfSamples);
      });
      for (var i = 0; i < numberOfSamples; i += 1) {
        var elementOffset = i * channelCount + 1;
        for (var j = 0; j < channelCount; j += 1) {
          content[j][i] = dataView.getFloat32(offset + length + (elementOffset + j) * Float32Array.BYTES_PER_ELEMENT, true);
        }
      }
      return {
        content: content,
        length: length + value
      };
    }
    return {
      content: null,
      length: length + value
    };
  };
};